import {IconModel} from "Core/Controls/BaseControl/Models/IconModel";

export class AccountsDtoModel {
	TableId: number;
	Icon: IconModel;
}